/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1056
 */

module.exports = {
  formGroup: "style_formGroup__2mvE-",
  formItemWrapper: "style_formItemWrapper__3Ugqj",
  main: "style_main__2Qk3P",
  label: "style_label__1oqVj",
  nowrap: "style_nowrap__15Xau",
  justifyInputContent: "style_justifyInputContent__21Mm-",
  justifyContentStart: "style_justifyContentStart__1a7aZ",
  radioWrapper: "style_radioWrapper__2VZZF",
  colorBlock: "style_colorBlock__1ui0l",
  slash: "style_slash__1V-hq",
  sizeInputBox: "style_sizeInputBox__2y-Es",
  sizeInputNumberBox: "style_sizeInputNumberBox__1rL8Q",
  typeSelector: "style_typeSelector__b4PR4",
  changeSizeFormItemWrapper: "style_changeSizeFormItemWrapper__2u4K5",
  sizeRadioBox: "style_sizeRadioBox__1kPY5",
  formWidgetTitle: "style_formWidgetTitle__9gg4k",
  formWidgetTitleWithDisableOrVisible: "style_formWidgetTitleWithDisableOrVisible__4SQeb",
  btnIcon: "style_btnIcon__1bTft",
  "coco-iconfont": "style_coco-iconfont__LIe9z",
  formInputNumberRow: "style_formInputNumberRow__325ER",
  formTitle: "style_formTitle__2eGUp",
  textInput: "style_textInput__1g8oj",
  space: "style_space__1BszP",
  optionSwitch: "style_optionSwitch__ZrEYp",
  option: "style_option__1Hw9L",
  activeOption: "style_activeOption__1MG_4",
  dialog: "style_dialog__2eif0",
  dialogContent: "style_dialogContent__3Fxk3",
  titleWrapper: "style_titleWrapper__37pUZ",
  title: "style_title__3VP9I",
  textWrapper: "style_textWrapper__ZJCxO",
  line: "style_line__209EK",
  firstLine: "style_firstLine__3ropS",
  secondLine: "style_secondLine__MxOPz",
  buttonWrapper: "style_buttonWrapper__2DjN8",
  button: "style_button__1gSEz",
  secondary: "style_secondary__100n2",
  primary: "style_primary__3QWG2",
  textButtonWrapper: "style_textButtonWrapper__2MS_2",
  fontFamilyWrapper: "style_fontFamilyWrapper__2o2UA",
  image: "style_image__1AMKW",
  downloadIcon: "style_downloadIcon__Fp819",
  iconBox: "style_iconBox__1vCvv",
  selectedIcon: "style_selectedIcon__7pDjb",
  disabled: "style_disabled__3VgCo",
  selected: "style_selected__1vCc3",
  headline: "style_headline__2jtK7"
}
